import { render, staticRenderFns } from "./OccurrencesCriteria.vue?vue&type=template&id=04984f0f&"
import script from "./OccurrencesCriteria.vue?vue&type=script&lang=js&"
export * from "./OccurrencesCriteria.vue?vue&type=script&lang=js&"
import style0 from "./OccurrencesCriteria.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
installComponents(component, {VCheckbox,VListItem,VListItemAction})
